<template>
  <div class="modal_card">
    <div class="header">
      <h4 class="title">
        {{ translate('comments.edit_comment') }}
      </h4>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ translate('comments.text_comment') }}</label>
            <textarea
              v-model="edit_comment.text"
              rows="5"
              class="form-control border-input"
              :placeholder="translate('comments.text_comment')"
            />
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="update_comment"
          :disabled='disabled_btn'
        >
          {{ translate("save") }}
        </button>
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="cancel"
        >
          {{ translate("close_modal") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "EditComment",
  props: ['comment'],
  data () {
    return {
      disabled_btn: false,
      edit_comment:{}
    }
  },
  created() {
    this.edit_comment = {...this.comment}
  },
  computed:{
    visible_list(){
      let comments_filters = this.$store.getters.getCommentsFilters
      let list = []
      for (let filter of comments_filters) {
        list.push({ label: this.translate(filter.name), id: filter.value})
      }
      return list
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    update_comment(){
      this.disabled_btn = true

      this.$http.v1.editComment(this.edit_comment, () => {
        this.global_notify('info', this.translate('comments.edit_comment_success'))
        this.$emit('update')
        this.$emit('close')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .modal_card{
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    padding: 10px;

    .header{
      .title{
        margin-top: 15px;
        text-align: center;
      }
    }
    .content{
      textarea{
        background-color: #fffcf5;
        border-radius: 4px;
        color: #66615b;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        box-shadow: none;
        border: 1px solid #e8e8e8;
        height: 200px;
      }
    }
  }

</style>
